import React, { forwardRef } from 'react';
import escapeRegExp from 'lodash-es/escapeRegExp';
import { Box, BoxProps } from '../Box/Box';

export interface EmboldenProps extends Omit<BoxProps, 'children'> {
  term?: string;
  children?: string;
}

export const MAX_TERM_LENGTH = 100;
export const Embolden = forwardRef<HTMLSpanElement, EmboldenProps>(({ children = '', term = '', ...rest }, ref) => {
  if (!term.trim() || !children) {
    return (
      <Box component="span" {...rest} ref={ref}>
        {children}
      </Box>
    );
  }
  const targetTerm = term.substring(0, MAX_TERM_LENGTH);
  const regex = new RegExp(`(${escapeRegExp(targetTerm)})`, 'gi');
  const parts = children.split(regex);
  return (
    <Box component="span" {...rest} ref={ref}>
      {parts
        .filter(Boolean)
        .map((part, i) =>
          regex.test(part) ? <b key={i.toString()}>{part}</b> : <span key={i.toString()}>{part}</span>
        )}
    </Box>
  );
});
